//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { isMobile } from "@/utils/is";
import Compressor from "compressorjs";
import MattingHeader from "./MattingHeader";
import MattingMain from "./MattingMain";
import { getQueryValue } from "@/utils/index";
import Storage from "@/utils/storage";
import { mapState } from "vuex";
const { utils, fsms, store } = window.MattingEngineModule;
const openFile = utils.openFile;

class Fsm {
  constructor(fsm) {
    this.fsms = {};
    if (fsm) {
      const key = fsm.service.id;
      this.fsms[key] = fsm;
    }
  }
  getFsm(key) {
    return this.fsms[key];
  }
}

function createFsm(fsm) {
  return new Fsm(fsm);
}
function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
  var dataURL = canvas.toDataURL("image/" + ext);

  return dataURL;
}
function btof(data, fileName) {
  const dataArr = data.split(",");
  const byteString = atob(dataArr[1]);

  const options = {
    type: "image/jpeg",
    endings: "native",
  };
  const u8Arr = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    u8Arr[i] = byteString.charCodeAt(i);
  }
  return new File([u8Arr], fileName + ".jpg", options);
}

function transFile(data, fileName) {
  const options = {
    type: "image/jpeg",
    endings: "native",
  };
  const blob = new Blob([data]);
  return new File([blob], fileName + ".jpg", options);
}

export default {
  components: {
    MattingHeader,
    MattingMain,
  },
  setup() {
    const mattingFsm = fsms.getMattingFsm();

    const { state, send } = mattingFsm;
    return {
      state,
      send,
      mattingFsm,
    };
  },
  data() {
    return {
      downApp: true,
    };
  },
  computed: {
    showMatting() {
      return !this.state.matches("idle") || Storage.get("action");
    },
    isZh() {
      return document.documentElement.lang === "zh";
    },
    ...mapState({
      identityToken: (state) => state.user?.identityToken,
      userInfo: (state) => state.user?.userInfo,
    }),
    isLogined() {
      return this.identityToken && this.userInfo;
    },
  },
  watch: {
    showMatting(val) {
      if (val) {
        document.getElementById("ap-header").style.display = "none";
        document.getElementsByTagName("footer")[0].style.display = "none";
      } else {
        document.getElementById("ap-header").style.display = "block";
        document.getElementsByTagName("footer")[0].style.display = "block";
      }
    },
  },
  async mounted() {
    this.$root.isComplete = true;

    // 处理从首页跳转过来的上传动作
    const action = Storage.get("action");
    const url = Storage.get("url");
    const resourceId = Storage.get("resourceId");
    const fileName = Storage.get("fileName") || "";
    const type = Storage.get("type");

    // Storage.remove("action");
    Storage.remove("url");
    Storage.remove("resourceId");
    Storage.remove("type");
    const fsms = this.$root.fsms;

    if (action === "process" && url) {
      const fsm = fsms.getFsm("matting");

      fsm.send({
        type: "REQUEST_MATTING",
        resourceId: resourceId,
        imageUrl: decodeURIComponent(url),
      });
    } else if (action === "process" && type) {
      this.createMattingTask(type);
    }
  },
  created() {
    this.$root.fsms = createFsm(this.mattingFsm);
    this.$root.$on("matting:create", this.createMattingTask);
    this.$root.$on("matting:download", this.downloadMatting);
  },
  methods: {
    imgToFile(imgurl, filename) {
      return new Promise((resolve) => {
        let image = new Image();
        image.setAttribute("crossOrigin", "Anonymous");
        image.src = imgurl;
        image.onload = function () {
          let base64 = getBase64Image(image);
          let file = btof(base64, filename ? filename : "test");
          resolve(file);
        };
      });
    },
    async createMattingTask(filetype) {
      const fsms = this.$root.fsms;
      if (
        filetype == "1" ||
        filetype == "2" ||
        filetype == "3" ||
        filetype == "4"
      ) {
        let imgurl =
          "https://qncdn.aoscdn.com/projects/picwish/img/index/eg" +
          filetype +
          ".jpg";
        const file = await this.imgToFile(imgurl);
        // setTimeout({
        const fsm = fsms.getFsm("matting");
        fsm.send({
          type: "REQUEST_MATTING",
          file,
        });
        // },1000)
      } else if (filetype && filetype.name) {
        //拖拽上传
        const fsm = fsms.getFsm("matting");
        fsm.send({
          type: "REQUEST_MATTING",
          file: filetype,
          mattingType: "",
        });
      } else {
        // const thattemp = this;
        openFile(function (files) {
          // if (!isMobile) {
          //   thattemp.modalappdoing(files, type);
          // } else {
          const file = files[0];
          const fsm = fsms.getFsm("matting");
          fsm.send({
            type: "REQUEST_MATTING",
            file,
            mattingType: "",
          });
          // }
        });
      }
      this.$children[1].$children[3].$children[0].$children[3].currentOption =
        "custom";
    },
    modalappdoing(files) {
      this.$root.processNum = 1;
      this.$root.modalAppStatus = "upload";
      this.$root.showModalApp = true;
      let bartimer = window.setInterval(() => {
        this.$root.processNum = parseInt(this.$root.processNum) + 1;
        this.$root.$refs.processWidth.style.width = this.$root.processNum + "%";
        if (this.$root.processNum == 90) {
          window.clearInterval(bartimer);
        }
      }, 55);
      setTimeout(() => {
        window.clearInterval(bartimer);
        //
        const file = files[0];
        const fsms = this.$root.fsms;
        const fsm = fsms.getFsm("matting");
        fsm.send({
          type: "REQUEST_MATTING",
          file,
          mattingType: "",
        });
        //
        window.bartimer90 = window.setInterval(() => {
          this.$root.processNum = parseInt(this.$root.processNum) + 1;
          this.$root.$refs.processWidth.style.width =
            this.$root.processNum + "%";
          if (this.$root.$refs.processWidth.style.width == "99%") {
            window.clearInterval(window.bartimer90);
          }
        }, 200);
      }, 5000);
    },
    showAccountDialog() {
      const { showAccountDialog } = useService("AccountService");
      showAccountDialog();
    },
    downloadMatting(type) {
      if (!this.isLogined) {
        this.showAccountDialog();
        return;
      }

      //弹窗引导下载
      this.$root.processNum = 1;
      this.$root.modalAppStatus = "download";
      this.$root.showModalApp = true;
      let bartimer = window.setInterval(() => {
        this.$root.processNum = parseInt(this.$root.processNum) + 1;
        this.$root.$refs.processWidth.style.width = this.$root.processNum + "%";
        if (this.$root.processNum == 99) {
          window.clearInterval(bartimer);
        }
      }, 50);
      setTimeout(() => {
        window.clearInterval(bartimer);
        let filename =
          (this.state.context.blob && this.state.context.blob.name) ||
          Storage.get("fileName");
        if (!filename) {
          filename = "picwish.png";
        }
        if (type === "advanced") {
          store.advancedManager.download(filename);
        } else {
          store.canvasManager.download(filename);
        }
        //
        this.$root.processNum = 100;
        this.$root.$refs.processWidth.style.width = this.$root.processNum + "%";
        this.$root.modalAppStatus = "finish";
      }, 5000);
    },
  },
};
